import {
  Avatar,
  CardHeader,
  Grid,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PrimaryOutlinedButton } from 'components';
import CertificateModal from '../certificate-modal';
import { ICertificate } from '../../../../interface';

interface ViewCertificateProps {
  formTitle: string,
  certificate: ICertificate | null | undefined;
  handleCertificate: (certificate: ICertificate) => void;
  handleCertificateRemove: () => void
}

const getCertificateSummary = (certificate: ICertificate) => {
  const summaryItems = [
    `Template: ${certificate.template.replace(/_/g, ' ')}`,
    certificate.logos?.length ? `${certificate.logos.length} logo(s)` : '',
    certificate.signatories?.length ? `${certificate.signatories.length} signatory(s)` : '',
    certificate.validity ? `Validity: ${certificate.validity.value} ${certificate.validity.unit.toLowerCase()}(s)` : '',
  ].filter(Boolean);

  return summaryItems.join(' | ');
};

const ViewCertificate = ({
  certificate,
  handleCertificate,
  handleCertificateRemove,
  formTitle,
}: ViewCertificateProps) => (
  <div>
    {!certificate?.title ? (
      <div>
        <CertificateModal
          add
          formTitle={formTitle}
          certificate={certificate}
          setCertificate={handleCertificate}
        />
      </div>
    ) : (
      <Grid container alignItems="center">
        <Grid item xs={10}>
          <CardHeader
            avatar={(
              <Avatar
                src={certificate.badge?.imageUrl || certificate.logos?.[0]?.logoUrl || ''}
                sx={{ width: 40, height: 40 }}
              />
            )}
            title={<Typography variant="h4">{certificate.title}</Typography>}
            subheader={(
              <div style={{ lineBreak: 'anywhere' }}>
                {getCertificateSummary(certificate)}
              </div>
            )}
            subheaderTypographyProps={{ noWrap: false }}
          />
        </Grid>
        <Grid item xs sx={{ textAlign: 'right' }}>
          <Grid container>
            <Grid item>
              <CertificateModal
                add={false}
                formTitle={formTitle}
                certificate={certificate}
                setCertificate={handleCertificate}
              />
            </Grid>
            <Grid item>
              <PrimaryOutlinedButton
                onClick={handleCertificateRemove}
                startIcon={<CloseIcon />}
              >
                Remove
              </PrimaryOutlinedButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )}
  </div>
);

export default ViewCertificate;
